/** Converts the backend's [r,g,b,a] float (0..1) format to a "#RRGGBB" hex
 * string for use in <input type="color">, which only accepts 6-digit hex. */
export function rgbFloatsToHex([r, g, b]: [number, number, number, number]): string {
  const toHex = (v: number) =>
    Math.round(Math.max(0, Math.min(1, v)) * 255)
      .toString(16)
      .padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
